import actions from 'modules/tool/form/toolFormActions';
import formReducers from 'modules/shared/form/formReducers';

export default formReducers(actions);
